import {
  MultiSelectorContentClose,
  MultiSelectorSeparator,
  MultiSelectorTrigger,
  MultiSelectorContent,
  MultiSelectorInput,
  MultiSelectorList,
  MultiSelectorItem,
  MultiSelector,
} from '@ui/components';
import { PropsWithChildren, useEffect, useState } from 'react';

export interface CostCenterMultiselectProps extends PropsWithChildren {
  options: { label: string; value: string }[];
  // selectionChange is to track control inner state without confirm button
  selectionChange?: (value: string[]) => void;
  onChange: (value: string[]) => void;
  buttonLabel: string;
  value: string[];
}

export const CostCenterMultiselect = ({
  selectionChange = () => {},
  buttonLabel,
  onChange,
  children,
  options,
  value,
}: CostCenterMultiselectProps) => {
  const [selected, setSelected] = useState<string[]>(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleSelectionChange = (value: string[]) => {
    setSelected(value);
    selectionChange(value);
  };

  return (
    <MultiSelector onValuesChange={handleSelectionChange} className="w-auto" values={selected}>
      <MultiSelectorTrigger asChild>{children}</MultiSelectorTrigger>
      <MultiSelectorContent>
        <MultiSelectorInput />
        <MultiSelectorSeparator />
        <MultiSelectorList>
          {options.map((option) => (
            <MultiSelectorItem label={option.label} value={option.value} key={option.value} />
          ))}
        </MultiSelectorList>
        <MultiSelectorSeparator />

        <div className="p-2">
          <MultiSelectorContentClose
            onClick={() => onChange(selected)}
            variant="primary"
            type="button"
            wide
          >
            {buttonLabel}
          </MultiSelectorContentClose>
        </div>
      </MultiSelectorContent>
    </MultiSelector>
  );
};
